import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/authservice/auth.service';


@Component({
  selector: 'app-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss'],
  standalone: false
})
export class LandingHeaderComponent implements OnInit {
  testValue = 'test';
  public isCollapsed = true;
  isLogin = false;
  isMobileView = false;
  userData: any;

  private subscription!: Subscription;
  constructor( public translate: TranslateService,
     private router: Router, 
    private authService: AuthService, 
    private eRef: ElementRef) { 
        if (document.documentElement.clientWidth <= 992) {
        this.isMobileView = true;
         }
      }
      closeNavbar(): void {
        if (window.innerWidth < 992) { // or any breakpoint you prefer
          this.isCollapsed = true;
        }
      }

      updateLogin(){
        this.isLogin = !this.isLogin;
      }
    
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event): void {
      // Check if the click was outside the navbar
      if (!this.eRef.nativeElement.contains(event.target)) {
        this.isCollapsed = true;
      }
    }

    toggleCollapse(): void {
      this.isCollapsed = !this.isCollapsed;
  } 

  ngOnInit(): void {
    const currentLang = localStorage.getItem('lang') || 'ar';
    this.translate.use(currentLang);

    this.subscription = this.authService.currentUser$.subscribe(user => {
      this.userData = user;
    });
  }


  /**
    * Window scroll method
    */
  // tslint:disable-next-line: typedef
  windowScroll() {
    // Top Btn Set
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      (document.getElementById("back-to-top") as HTMLElement).style.display = "block"
    } else {
      (document.getElementById("back-to-top") as HTMLElement).style.display = "none"
    }
  }
  logout(): void {
    //return to sign in page
    this.router.navigate(['/auth/login']);
    this.authService.signOut(); // Logout happens immediately
  }
  setLanguage(lang: string) {
    const storageKey = 'lang';
    localStorage.setItem(storageKey, lang);
  
    // Debugging: Check if the language was successfully set
    const storedLang = localStorage.getItem(storageKey);
    if (storedLang === lang) {
      //this.menuService.clearMenuCache();
      window.location.reload(); // Reload to apply the language change
    } else {
      console.error('Failed to set the language.');
    }
  }
  //find language from cookies, ar or en only for now
  isArLang() {
    const lang =this.translate.currentLang;
    return lang === 'ar'? true : false;
  }


}
